import { z } from 'zod';

export const TSDInvalidateSchema = z.object({
  tsdId: z.string().min(1, { message: 'Required' }),
  reason: z.string().min(1, { message: 'Required' }),
});

export type TSDInvalidateData = z.infer<typeof TSDInvalidateSchema>;
